import { useLocation, useNavigate } from "react-router-dom";

export default function GeneratedBills() {
    const { state } = useLocation();
    const navigate = useNavigate();

    const bills = state?.bills || [];

    if (!bills.length) {
        return (
            <div className="container mt-4">
                <h5>No Bills Found</h5>
                <button className="btn btn-dark mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
        );
    }

    return (
        <div className="container mt-4">
            <h3 className="mb-4">Generated Bills</h3>

            {bills.map((bill) => (
                <div key={bill.id} className="card mb-4 shadow-sm">

                    {/* Bill Header */}
                    <div className="card-header d-flex justify-content-between">
                        <div>
                            <strong>Bill #{bill.id}</strong>
                        </div>
                        <div>{bill.formattedDate}</div>
                    </div>

                    {/* Orders */}
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-sm align-middle">
                                <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Description</th>
                                        <th>Size</th>
                                        <th>Qty</th>
                                        <th>Rate</th>
                                        <th>SqFt</th>
                                        <th>Amount</th>
                                        <th>QR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bill.orders.map((order) => (
                                        <tr key={order.id}>

                                            <td>
                                                <img
                                                    src={order.imagePath}
                                                    alt=""
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        objectFit: "cover",
                                                        borderRadius: "6px"
                                                    }}
                                                />
                                            </td>

                                            <td>{order.description}</td>

                                            <td>
                                                {order.height} × {order.width}
                                            </td>

                                            <td>{order.quantity}</td>

                                            <td>₹{order.rate}</td>

                                            <td>{order.totalSquareFeet.toFixed(2)}</td>

                                            <td>₹{order.amount.toFixed(2)}</td>

                                            <td>
                                                <img
                                                    src={order.qrCodePath}
                                                    alt="QR"
                                                    style={{ width: "50px" }}
                                                />
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Total */}
                        <div className="text-end mt-3">
                            <h5>Total: ₹{bill.totalAmount.toFixed(2)}</h5>
                        </div>
                    </div>
                </div>
            ))}

            <button className="btn btn-dark" onClick={() => navigate(-1)}>
                Back
            </button>
        </div>
    );
}